import { MspParentAssociationPayload } from '../MspParentWizard';
import { AssociationOutcome } from '../../../helpers/types';
import { postMspChildrenAssociation } from '../../../helpers/postMspChildrenAssociation';

export const runMspParentMigration = (
  payload: MspParentAssociationPayload
): Promise<AssociationOutcome> => {
  // Do not log - payload contains secretKey and clientId.
  const body = {
    tenantIds: payload.selectedChildIds,
    mspParentTenantUUID: payload.credentials.parentUuid,
    clientId: payload.credentials.clientId,
    accessKey: payload.credentials.secretKey,
    adminEmail: payload.credentials.adminEmail
  };

  return postMspChildrenAssociation(body);
};
